import { render } from "./MainPage.vue?vue&type=template&id=c7cd9f1e&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=ts"
export * from "./MainPage.vue?vue&type=script&lang=ts"

import "./MainPage.vue?vue&type=style&index=0&id=c7cd9f1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c7cd9f1e"

export default script